<template>
  <div>
    <Header/>
    <Navigationzj/>
    <div class="new_detail w1200" v-loading="qyloading">
      <h1>{{ detail.title }}</h1>
      <div class="new_detail_font">
        <em><img src="../../assets/images/zp_21.png">{{detail.addtime}}</em>
        <em><img src="../../assets/images/zp_23.png"> {{detail.hit}}次</em>
        <div class="new_detail_fontclose">
          <!-- 字体 【<a href="javascript:doZoom(16)">大</a>
          <a href="javascript:doZoom(14)">中</a>
          <a href="javascript:doZoom(12)">小</a>】 -->
          <a title="关闭" href="javascript:window.close();"> 关闭</a>
        </div>
      </div>
      <div class="new_detail_info" id="Zoom" v-html="detail.content"></div>
      <p class="shengming">声明：本文素材来源于网络，如有侵权，可联系删除。</p>
      <div class="up_down">
        <router-link class="clearfix" :to="{path:'/InfoDetail', query:{id:up.id}}" :title="up.title" v-if="up">
          <em>上一篇</em><span>{{up.title}}</span>
        </router-link>
        <a class="clearfix" title="已经是第一篇了" v-else>
          <em>上一篇</em><span>已经是第一篇了</span>
        </a>
        <router-link class="clearfix" :to="{path:'/InfoDetail', query:{id:down.id}}" :title="down.title" v-if="down">
          <em>下一篇</em><span>{{down.title}}</span>
        </router-link>
        <a class="clearfix" title="已经是最后一篇了" v-else>
          <em>下一篇</em><span>已经是最后一篇了</span>
        </a>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>

import api from '@/api/resources'
import Header from '@/components/Resources/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'

export default {
  name: 'Faster',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  inject: ['reload'], // 注入依赖
  data () {
    return {
      detail: {},
      up: '',
      down: '',
      qyloading: false
    }
  },
  watch: {
    $route (to, from) {
      this.reload()
    }
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    getDetail () {
      this.qyloading = true
      api.getDetail({id: this.$route.query.id}).then(res => {
        this.detail = res.items
        this.up = res.up
        this.down = res.down
        this.qyloading = false
      })
    }
  }
}
</script>
<style scoped>
 .shengming {
    color: #bdc3c7;
    margin-bottom: 30px;
    padding-left: 100px;
 }
 .new_detail_info {
    padding: 44px 100px;
 }
</style>



// WEBPACK FOOTER //
// src/view/resources/info_detail.vue